/**
 * Centralized test IDs for admin app UI testing with Playwright.
 *
 * Naming convention: {component}-{descriptor}-{type}
 *
 * Usage convention: Always place data-testid attributes at the END of component props.
 */

export const COMPONENTS = {
    HEADER: "admin-header-",
    FOOTER: "admin-footer-",
    DASHBOARD: "admin-dashboard-",
} as const;

const TYPES = {
    CONTAINER: "-container",
    BUTTON: "-button",
    TEXT: "-text",
} as const;

export const HEADER = {
    CONTAINER: COMPONENTS.HEADER + "container",
    LOGO_BUTTON: COMPONENTS.HEADER + "logo" + TYPES.BUTTON,
    BRAND_NAME: COMPONENTS.HEADER + "brand-name" + TYPES.TEXT,
    NOTIFICATIONS_BUTTON: COMPONENTS.HEADER + "notifications" + TYPES.BUTTON,
    MENU_BUTTON: COMPONENTS.HEADER + "menu" + TYPES.BUTTON,
} as const;

export const FOOTER = {
    CONTAINER: COMPONENTS.FOOTER + "container",
    HOME_BUTTON: COMPONENTS.FOOTER + "home" + TYPES.BUTTON,
    CALENDAR_BUTTON: COMPONENTS.FOOTER + "calendar" + TYPES.BUTTON,
    AI_BUTTON: COMPONENTS.FOOTER + "ai" + TYPES.BUTTON,
    CHAT_BUTTON: COMPONENTS.FOOTER + "chat" + TYPES.BUTTON,
    USERS_BUTTON: COMPONENTS.FOOTER + "users" + TYPES.BUTTON,
} as const;

export const DASHBOARD = {
    CONTAINER: COMPONENTS.DASHBOARD + "container",
} as const;
